import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SpeciesService {

  constructor(private http: HttpClient) { }

  getSpeciesByCountryByLanguage(pCountry: string, pLanguage: string) {
    return this.http.get("https://api.globalbirdwatching.org/db/especiesporpaisporidioma?idioma=" + pLanguage + "&pais=" + pCountry);
  }

  getSpeciesByOrderByLanguage(pOrder: string, pLanguage: string) {
    return this.http.get("https://api.globalbirdwatching.org/db/especiespororderporidioma?idioma=" + pLanguage + "&order=" + pOrder);
  }

  getSpeciesByOrderByFamilyByLanguage(pFamily: string, pOrder: string, pLanguage: string) {
    return this.http.get("https://api.globalbirdwatching.org/db/especiespororderporfamiliaporidioma?idioma=" + pLanguage + "&order=" + pOrder + "&family=" + pFamily);
  }

  getSpeciesByHotSpot(pLocId: string, pIdioma: string) {
    return this.http.get('https://api.globalbirdwatching.org/db/especiesporpuntoavistamientoporidioma?idioma=' + pIdioma + '&hotspost=' + pLocId);
  }

  getSpeciesByColorByIdioma(pIdioma: string, pColor: string) {
    console.log(pColor);
    return this.http.get('https://api.globalbirdwatching.org/db/especieporcolorporidioma?idioma=' + pIdioma + '&color=' + pColor);
  }

  getFamilies() {
    return this.http.get('https://api.globalbirdwatching.org/db/familias');
  }

  getColoresPorOrder(pOrder: string) {
    return this.http.get('https://api.globalbirdwatching.org/db/colorespororder?order=' + pOrder);
  }

  getColoresPorOrderPorFamilia(pOrder: string, pFamilia) {
    return this.http.get('https://api.globalbirdwatching.org/db/colorespororderporfamilia?order=' + pOrder + '&family=' + pFamilia);
  }

}
